module.exports = __webpack_public_path__ + "static/media/CECAP.395fefb5.png";